import React, {Component} from 'react';
import PropTypes from 'prop-types'
import POIProvider from './poi_provider';
import ProductProvider from './product_provider';

class SearchBox extends Component {
  render() {
    const searchEndpoint = this.props.searchEndpoint;

    return (
      <div>
        { searchEndpoint == '/products' &&
          <ProductProvider searchEndpoint={ searchEndpoint } />
        }
        { searchEndpoint != '/products' &&
          <POIProvider searchEndpoint={ searchEndpoint } />
        }
      </div>
    );
  }
}

SearchBox.propTypes = {
  searchEndpoint: PropTypes.string.isRequired
};

export default SearchBox;



// WEBPACK FOOTER //
// ./app/webpack/packs/javascripts/searchBox/searchBox.jsx